import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import { Button, Input, Form, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import apiService from '../services/apiService.js';
import Cookies from 'js-cookie';
import logo from '../assets/APPlyzerLogoHead.svg';

const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { checkAuthStatus } = useAuth();

  const handleLogin = async (values) => {
    setLoading(true);
    setError('');

    try {
      const response = await apiService.login(values.email, values.password);
      
      if (response && response.access_token) {
        // Set the JWT token in cookies
        Cookies.set('login_jwt', response.access_token, {
          sameSite: 'none',
          secure: true
        });
        
        // Trigger the auth context to check and update the user state
        checkAuthStatus();
      } else {
        setError('Login failed. Invalid response from server.');
      }
    } catch (error) {
      setError(error.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img 
            src={logo} 
            alt="APPlyzer" 
            style={{ height: '48px', marginBottom: '16px' }}
          />
          <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b', margin: 0 }}>
            APPlyzer Compliance
          </h1>
          <p style={{ color: '#64748b', margin: '8px 0 0 0' }}>
            Sign in to your account
          </p>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            style={{ marginBottom: '20px' }}
            closable
            onClose={() => setError('')}
          />
        )}

        <Form
          name="login"
          onFinish={handleLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please input your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email address"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                border: 'none',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;